import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {LinearProgress , FormControlLabel, Switch, Avatar, Container, Card, Button, TextField, Typography, CardContent, CardHeader, Dialog , TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Link, Checkbox, Box, DialogTitle, DialogContent,DialogActions } from '@mui/material';
import { Attachment as AttachmentIcon, Settings as SettingsIcon } from '@mui/icons-material';
import { IconButton, Drawer, useMediaQuery } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import CompanyLogo from '../CompanyLogo';
import Linkedin from '@mui/icons-material/LinkedIn';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import EditIcon from '@mui/icons-material/Edit';
import Setup from './Setup';
import { useAuth } from '../AuthContext';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from "quill";
import EmailAnalyticsPanel from './EmailAnalyticsPanel';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import EditSidebar from './EditSidebar';
import { Snackbar, Alert } from '@mui/material';
import ResponsiveDecisionMakerList from './ResponsiveDecisionMakerList';

// Custom block format to force <div> instead of <p>
/*const Block = Quill.import("blots/block");
Block.tagName = "div"; // Changes default paragraph tag from <p> to <div>
Quill.register(Block, true);
*/
const Reachouts = ({ decisionMakers = [], Project, fetchDecisionMakers,selectedCompany, setSelectedCompany }) => {
  
dayjs.extend(utc);
dayjs.extend(timezone);
    const quillRef = useRef(null); // Use useRef instead of createRef
    const { user } = useAuth();
    const [reason, setReason] = useState("");
    const [preview, setPreview] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [i, setI] = useState(-1);
    const [OpenPreview, setOpenPreview] = useState(false);
    const [selectedDecisionMakers, setSelectedDecisionMakers] = useState([]);
    const [email, setEmail] = useState({});
    const [emails, setEmails] = useState([]);
    const [status, setStatus] = useState(() => localStorage.getItem('Reachoutstatus') || "Initial Outreach Pending");
    const [template, setTemplate] = useState(() => localStorage.getItem('template') || "");
    const DueDays =0;
    const [editorKey, setEditorKey] = useState(0);
    const [isChecked, setIsChecked] = useState(false);
    const [showEditSidebar, setShowEditSidebar] = useState(false);
    const [selectedDecisionMaker, setSelectedDecisionMaker] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // 'success' | 'error'
    const [scheduledAt, setScheduledAt] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));    
    const [showWeekendDialog, setShowWeekendDialog] = useState(false);


const [quillContent, setQuillContent] = useState('');
/*
useEffect(() => {
    if (preview[i]?.body) {
        setQuillContent(preview[i].body); // Ensure content updates immediately
        if(editorKey === 0)
            setEditorKey(1); // Force re-render
    }
}, [i, preview,editorKey ]); // Re-run whenever `i` changes  */
    const statuses = {
        'candidate': ["Initial Outreach Pending", "Followup Pending", "Closing Outreach Pending", "Outreach Completed", "Response Received","Rejected"],
        'admin': ["Suggested","Approved","Initial Outreach Pending", "Followup Pending", "Closing Outreach Pending", "Outreach Completed", "Response Received","Rejected"],
        'recruiter': ["Suggested","Approved","Initial Outreach Pending", "Followup Pending", "Closing Outreach Pending", "Outreach Completed", "Response Received","Rejected"],
    }
    const filterstatus = {
        "Suggested":["Suggested"],
        "Approved": ["Approved"],
        "Initial Outreach Pending": ["Initial Outreach Pending"], 
        "Followup Pending": ["Initial Outreach"], 
        "Closing Outreach Pending": ["Follow up"], 
        "Outreach Completed": ["Closing Outreach"], 
        "Response Received": ["Response Received", "Positive Outcome", "Negative Outcome"],        
        "Rejected": ["Rejected"]
    };
    useEffect(() => {
        localStorage.setItem('Reachoutstatus', status);
    }, [status]);

    useEffect(() => {
        localStorage.setItem('template', template);
    }, [template]);
    const [showSettings, setShowSettings] = useState(false);
    const [showAnalytics, setShowAnalytics] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [ModalDMId, setModalDMId] = useState('');
    const [ModalStatus, setModalStatus] = useState('');
    const [newComment, setNewComment] =useState('');
    const [loading, setLoading] = useState(false);

    async function AIrewrite() {
        setLoading(true); // Show the loading spinner
        console.log(JSON.stringify(preview));
        console.log(preview[i]);
        try {
            const response = await axios.post('/api/ai/prompt', {
               prompt: `Rewrite the following email to maximize relevance and response from a senior decision-maker (Founder, CXO, or Hiring Manager).  
The sender is a senior professional discreetly exploring strategic leadership roles.

Adopt a confident, peer-level tone—position the sender as a credible equal, not a job seeker.  
Use the recipient’s LinkedIn profile (provided below) to personalize the message with relevant references to their role, company context, strategic priorities, or shared interests.

Do NOT mention job search or ask for a role explicitly. Focus on sparking a strategic, high-trust conversation.  
Be concise and signal-driven—every line should earn its place.

Maintain the original HTML tags and structure exactly (for compatibility with outreach automation tools).  
Output only the rewritten email body—no explanations, headers, or commentary.



Recipient LinkedIn:`+ preview[i].data.candidateId.linkedin+
` Original email: ` + preview[i].body            });
            if (response.status === 200) {
                const updatedPreview = [...preview];
                updatedPreview[i].body = response.data;
                setPreview(updatedPreview);
                setLoading(false); // Hide the loading spinner
            } else {
                setSnackbarMessage('Failed to update email body.');
                setSnackbarSeverity('error');   
                setSnackbarOpen(true);
                setLoading(false); // Hide the loading spinner
            }
        } catch (error) {
            console.error('Error updating email body:', error);
            setSnackbarMessage('Something went wrong. Try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoading(false); // Hide the loading spinner
        }
    }

    async function fetchemails() {
        try {
            const response = await axios.get(`/api/fetchemails/${Project.email}`);
            setEmails(response.data);
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    }
    const handleUpdate = async (updatedData) => {
        try {
          const response = await axios.post('/api/execedge/updateDecisionMaker', {
            ExecEdgeId: Project._id,
            candidateId: updatedData.candidateId || selectedDecisionMaker?.candidateId?._id,
            updateFields: updatedData,
          });
      
          if (response.status === 200) {
            setSnackbarMessage('Decision Maker updated successfully!');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            fetchDecisionMakers();  // Refresh the list
            setShowEditSidebar(false);  // 👈 Close the sidebar after update
          } else {
            setSnackbarMessage('Failed to update decision maker.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
          }
        } catch (error) {
          console.error('Error updating decision maker:', error);
          setSnackbarMessage('Something went wrong. Try again.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      };
      

    useEffect(() => {
        const interval = setInterval(() => {
            fetchemails();
        }, 30000); // 10 seconds

        return () => clearInterval(interval);
    });

    const handleCloseModal = () => {
        setOpenModal(false);
    } 

    const handleSubmit = async (newComment) => {
        try {
            // Update connection status
            await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                ExecEdgeId: Project._id,
                candidateId: ModalDMId,
                Status: ModalStatus,
            });
    
            // Push the entire comment block to the backend
            await axios.post('/api/execedge/addAssoComment', {
                execEdgeId: Project._id, // Ensure consistency with backend parameter names
                decisionMakerId: ModalDMId,
                comment: newComment, // Pass the full comment block
            });
    
            // Refresh data and close the modal
            fetchDecisionMakers();
            setOpenModal(false);
        } catch (error) {
            console.error('Error updating connection status:', error);
        }
    };
    
      

  useEffect(() => {
    const fetchTemplates = async () => {
        try {
            const response = await axios.get(`/api/emailTemplates/project/${Project._id}`);
            setTemplates(response.data);
            //setTemplate(response.data.find(t => t.name === "Initial Outreach")._id);
            if(response.data.length > 0)
            switch(status)
                            {   default:
                                case "Initial Outreach Pending": 
                                    setTemplate(response.data.find(t => t.name === "Initial Outreach")._id);
                                    break;
                                case "Followup Pending": 
                                    setTemplate(response.data.find(t => t.name === "Follow up")._id);
                                    break;
                                case "Closing Outreach Pending":
                                    setTemplate(response.data.find(t => t.name === "Closing Outreach")._id);
                                    break;
                                case "Outreach Completed": 
                                    setTemplate('');
                                    break;
                                case "Response Received": 
                                    setTemplate('');
                                    break;
                                case "Rejected": 
                                    setTemplate('');
                                    break;
                            }
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    }
    fetchemails();
    fetchTemplates();
    }, [Project]);

    const ChangeStatus = async (candidateId, Status) => {
        try {
            await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                ExecEdgeId: Project._id,
                candidateId,
                Status,
            });            
            fetchDecisionMakers();
            setSelectedDecisionMakers([]);
        } catch (error) {
            console.error('Error updating connection status:', error);
        }
    }


    const handleStatus = async (candidateId, Status) => {
        setOpenModal(true);
        setModalDMId(candidateId);
        setModalStatus(Status);
    }

    const handlePreview = async (templateId, decisionMaker) => {
        let decisionMakersToUse = decisionMaker ? [decisionMaker] : selectedDecisionMakers;
        setSelectedDecisionMakers(decisionMakersToUse);
        let prev = [];
        const previews = await Promise.all(decisionMakersToUse.map(async (dm) => {
            try {
                let dmkr = decisionMakers.find(d => d._id === dm);
                const company = Project.TargetCompany.find(tc => tc.Organization === dmkr.TargetCompanyId);                
                let data = { ...dmkr, ...Project, "Recipient's Company Name": company ? company.Name : "","Recipient's First Name": dmkr.FirstName };
                const response = await axios.post('/api/emailTemplates/preview', { templateId, data });
                return response.data;
            } catch (error) {
                console.error('Error previewing template', error);
                return null;
            }
        }));
        const validPreviews = previews.filter(p => p !== null);        
        setPreview(validPreviews);
        // Show warning popup if it's Friday, Saturday, or Sunday
        const currentDay = new Date().getDay();
        if ([5, 6, 0].includes(currentDay)) {
            setOpenPreview(false);  // Close preview dialog first
            setShowWeekendDialog(true); // Show custom dialog
            // Dialog will handle showing preview if confirmed
            // Preview will only open after user confirms in the weekend warning dialog                                          
        }        
        else {
        setOpenPreview(true);
        }
        setI(0);
    }
    /*
    useEffect(() => {
        if (preview.length > 0) setOpenPreview(true);
    }, [preview]);
    */
    const sanitizeEmailBody = (html) => {
        if (typeof html !== 'string') {
            console.warn('sanitizeEmailBody received non-string input:', html);
            return '';
        }
        return html
            .replace(/<p>/g, '<div>')
            .replace(/<\/p>/g, '</div>')
         //   .replace(/<div><br><\/div>/g, '')
            .replace(/(<br>\s*){2,}/g, '<br><br>');
    };
        
    const SendEmail = async () => {
        preview.forEach(async (p) => {
            try {
                await axios.post('/api/emails/send', { 
                    from: user.email, 
                    to: p.data["WorkEmail"], 
                    subject: p.subject, 
                    body: sanitizeEmailBody(p.body),
                    name: templates.find(t => t._id === p.id).name,
                    scheduledAt: scheduledAt || null,
                });                
            
            await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                ExecEdgeId: Project._id,
                candidateId: p.data.candidateId._id,
                Status: templates.find(t => t._id === p.id).name,
            });
            
        setSelectedDecisionMakers([]);
        setOpenPreview(false);
        fetchDecisionMakers();
        fetchemails();//*/
        } catch (error) {
                console.error('Error sending email', error);
            }
        });
        
    }
    const handelSendEmail = async (templateId) => {
        selectedDecisionMakers.forEach(async (dm) => {       
        try {
            let dmkr = decisionMakers.find(d => d._id === dm);
            const company = Project.TargetCompany.find(tc => tc.Organization === dmkr.TargetCompanyId);            
            let data = { ...dmkr, ...Project, "Recipient's Company Name": company ? company.Name : "","Recipient's First Name": dmkr.FirstName };
            const response = await axios.post('/api/email/sendusingtemlpate', { templateId, data });
            await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                ExecEdgeId: Project._id,
                candidateId: data.candidateId._id,
                Status: templates.find(t => t._id === templateId).name,
            });
            setSelectedDecisionMakers([]);
            setOpenPreview(false);
            fetchDecisionMakers();
            fetchemails();
        } catch (error) {
            console.error('Error sending email', error);
        }
    });
    }

    return (
        <Container>
                        

            {/* Filters */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
                           
            {/* Floating Button Only on Mobile */}
{isMobile && (
  <IconButton
    onClick={() => setDrawerOpen(true)}
    sx={{
      position: 'fixed',
      bottom: 80,
      right: 16,
      backgroundColor: 'primary.main',
      color: 'white',
      zIndex: 1300,
      boxShadow: 3,
      '&:hover': { backgroundColor: 'primary.dark' }
    }}
  >
    <FilterListIcon />
  </IconButton>
)}

{/* Drawer Showing Filters */}
<Drawer anchor="bottom" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
  <Box sx={{ p: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
    {statuses[user.role]?.map((state) => (
      <Button
        key={state}
        variant="contained"
        color={status === state ? 'info' : 'inherit'}
        size="small"
        onClick={() => {
          setStatus(state);
          setDrawerOpen(false);
          setShowSettings(false);
          setShowAnalytics(false);
          setSelectedDecisionMakers([]);

          switch (state) {
            case 'Initial Outreach Pending':
              setTemplate(templates.find(t => t.name === 'Initial Outreach')._id);
              break;
            case 'Followup Pending':
              setTemplate(templates.find(t => t.name === 'Follow up')._id);
              break;
            case 'Closing Outreach Pending':
              setTemplate(templates.find(t => t.name === 'Closing Outreach')._id);
              break;
            default:
              setTemplate('');
          }
        }}
      >
        {state} ({decisionMakers.filter(dm => filterstatus[state]?.includes(dm.status)).length})
      </Button>
    ))}
  </Box>
</Drawer>
{!isMobile && (
  <Box display="flex" justifyContent="left" gap={1} width="70%">
    {statuses[user.role]?.map((state) => (
      <Button
        key={state}
        variant="contained"
        color={status === state ? 'info' : 'inherit'}
        size="small"
        onClick={() => {
          setStatus(state);
          setShowSettings(false);
          setShowAnalytics(false);
          setSelectedDecisionMakers([]);

          switch (state) {
            case 'Initial Outreach Pending':
              setTemplate(templates.find(t => t.name === 'Initial Outreach')._id);
              break;
            case 'Followup Pending':
              setTemplate(templates.find(t => t.name === 'Follow up')._id);
              break;
            case 'Closing Outreach Pending':
              setTemplate(templates.find(t => t.name === 'Closing Outreach')._id);
              break;
            default:
              setTemplate('');
          }
        }}
      >
        {state} ({decisionMakers.filter(dm => filterstatus[state]?.includes(dm.status)).length})
      </Button>
    ))}
  </Box>
)}

                           
            <Box display="flex" justifyContent="right" gap={2}>
            
            
            <IconButton
                
            sx={isMobile ? { 
                position: 'fixed',
                bottom: 180,
                right: 16,
                backgroundColor: 'primary.main',
                color: 'white',
                zIndex: 1300,
                boxShadow: 3,
                fontSize: '1rem',
                '&:hover': { backgroundColor: 'primary.dark' } 
            } : {
                backgroundColor: 'primary.main',
                color: 'white',
                zIndex: 1300,
                boxShadow: 3,
                fontSize: '1rem',
                '&:hover': { backgroundColor: 'primary.dark' } }}            
                onClick={() => {
                    showAnalytics ? setShowAnalytics(false) : setShowAnalytics(true);
                }}
            >
                {showAnalytics ? "Hide" :  <AnalyticsIcon />}
            </IconButton>
            
            
            <IconButton
                
                onClick={() => {
                    showSettings ? setShowSettings(false) : setShowSettings(true);
                }}
                sx={isMobile ? { 
                    position: 'fixed',
                    bottom: 140,
                    right: 16,
                    backgroundColor: 'primary.main',
                    color: 'white',
                    zIndex: 1300,
                    boxShadow: 3,
                    fontSize: '1rem',
                    '&:hover': { backgroundColor: 'primary.dark' } 
                } : {
                    backgroundColor: 'primary.main',
                    color: 'white',
                    boxShadow: 3,
                    fontSize: '1rem',
                    '&:hover': { backgroundColor: 'primary.dark' } }}
            >
               {showSettings ? "Hide" :<SettingsIcon />} 
            </IconButton>
            </Box>
            </Box>

            {showSettings && (
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
                    <Setup Project={Project} />
                </Box>
            )}
            {showAnalytics && (
            <EmailAnalyticsPanel decisionMakers={decisionMakers} emails={emails} companies={Project.TargetCompany} />
            )}
            { (!showSettings || !showAnalytics) && (
            <ResponsiveDecisionMakerList
            decisionMakers={decisionMakers}
            selectedDecisionMakers={selectedDecisionMakers}
            setSelectedDecisionMakers={setSelectedDecisionMakers}
            status={status}
            filterstatus={filterstatus}
            DueDays={DueDays}
            Project={Project}
            user={user}
            template={template}
            templates={templates}
            handlePreview={handlePreview}
            handleStatus={handleStatus}
            ChangeStatus={ChangeStatus}
            setSelectedDecisionMaker={setSelectedDecisionMaker}
            setShowEditSidebar={setShowEditSidebar}
            setEmail={setEmail}
            emails={emails}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
          />
          
            )}
        
{//    <Modal open={OpenPreview} width="80%" onOk={() => /* handelSendEmail(preview[0]?.id)*/SendEmail()} onCancel={() => setOpenPreview(false)} okText="Send Mail">
 }
  <Dialog open={OpenPreview} onClose={() => setOpenPreview(false)} 
 fullWidth={true} maxWidth= {isMobile ? "sm" : "md"}>
    <DialogTitle>Subject: {preview[i]?.subject}</DialogTitle>
    <DialogContent>
    {loading && <LinearProgress />}   
    <div id="text" style={{
 //   backgroundColor: "#f2f2f2", // Light gray Gmail background
    display: isChecked? "none": "flex",
    justifyContent: "center",
    padding: "20px"
}}>
    <div style= {isMobile ? {
       
        padding: "6px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        maxWidth: "90%",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        width: "100%",
        overflow: "hidden",
    } : {
        //backgroundColor: "#ffffff",
        padding: "16px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        maxWidth: "90%",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
    }}>

<Box
  sx={{
    fontFamily: "'Roboto', sans-serif",
    fontSize: "14px",
    lineHeight: 1.5,
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
    margin: 0,
    padding: 0,
    '& p': {
      margin: 0,
      padding: 0,
    },
    '& div': {
      margin: 0,
      padding: 0,
    },
  }}
  dangerouslySetInnerHTML={{ __html: preview[i]?.body }}
/>

    </div>
</div>

        
<ReactQuill
    id="editor"
    //key={editorKey}
    ref={quillRef} // Attach ref directly
    value={preview[i]?.body} //{quillContent} 
    onChange={(value) => {
        //setQuillContent(value);
        if (preview[i]?.body !== value) { 
            const updatedPreview = [...preview];
            updatedPreview[i].body = value;
            setPreview(updatedPreview);
        }
    }} 
    style={{ height: '250px', border: '1px solid #ececec', borderRadius: '8px',display: isChecked? 'block':'none' }}
    modules={{
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image'],
            ['clean'],
        ],
        clipboard: { matchVisual: false },
    }}
    formats={['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link', 'image','div']}
/>
    </DialogContent>
    <DialogActions>
    <div style={{display: 'flex', justifyContent: 'flex-start', float: 'left'}}>   
    {preview.length > 1 && (
        <>
            <Button
                disabled={i === 0 && preview.length === 1}
                variant="contained"
                color="secondory"
                onClick={() => setI((i - 1 + preview.length) % preview.length)}
            >
                <NavigateBeforeIcon color="secondory" />
            </Button>
        
            <Button
                disabled={i === preview.length - 1 && preview.length === 1}
                variant="contained"
                color="secondory"
                onClick={() => setI((i + 1) % preview.length)}
            >
                <NavigateNextIcon color="primary" />
            </Button>
            </>
        )}
        </div>
        {preview.length === 1 && (
            <>
        <Button variant='outlined' color='primary' >
        <FormControlLabel
            control={
        <Switch
            checked={isChecked}
            onChange={() => {
                const textElement = document.getElementById('text');
                const editorElement = document.getElementById('editor');
                if (textElement.style.display === 'none') {
                    textElement.style.display = 'block';
                    editorElement.style.display = 'none';                    
                } else {
                    textElement.style.display = 'none';
                    editorElement.style.display = 'block';
                }              
              setIsChecked(prev => !prev);
            }}
            color="primary"
            name="toggleEdit"
            inputProps={{ 'aria-label': 'Toggle Edit' }}
        />    }
        label="Personalise Email"
        /></Button>
        <Button variant='outlined' color='primary' startIcon={<AutoAwesomeIcon />} onClick={() => AIrewrite()}> Rewrite with AI </Button>
        </>
    )}
            <TextField
                id="datetime-local"
                label="Schedule Email"
                type="datetime-local"
                value={
                      scheduledAt
                        ? dayjs(scheduledAt).tz('Asia/Kolkata').format('YYYY-MM-DDTHH:mm')
                        : ''
                    }
                //value={scheduledAt ? new Date(scheduledAt).toISOString().slice(0, 16) : ''}
                onChange={(e) => setScheduledAt(new Date(e.target.value))}
                InputLabelProps={{
                    shrink: true,
                }}
                sx={{ width: 250 }}
            />
    <Button variant='contained' onClick={() => SendEmail()} color="primary">Send</Button>
    </DialogActions>
</Dialog>

            <Dialog open={!!email.to} maxWidth="md" fullWidth onClose={() => setEmail({})}>
            <DialogTitle>Email Details</DialogTitle>
            <DialogContent>
            <Card
            sx={{
            padding: 2,
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            maxHeight: "75vh",
            overflowY: "auto",
            }}
            >
            <CardHeader
            title={email.subject || "No Subject"}
            titleTypographyProps={{
            variant: "h6",
            fontWeight: "bold",
            color: "primary",
            textAlign: "center",
            }}
            sx={{ paddingBottom: 0 }}
            />
            <CardContent>
            <Box
            sx={{
            padding: 2,
            border: "1px solid #ececec",
            borderRadius: "8px",
            fontSize: "0.9rem",
            lineHeight: 1.5,
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
            }}
            dangerouslySetInnerHTML={{
                __html: email.body
                  ? email.body
                      // Replace tracking URLs inside anchor tags (`<a href="..."`)
                      .replace(
                        /<a\s+[^>]*href=["']?https:\/\/vibrant-catbird-399009\.el\.r\.appspot\.com\/click\/\S+\?url=([^"&]+)[^>]*>(.*?)<\/a>/gi,
                        (match, p1, linkText) =>
                          `<a href="${decodeURIComponent(p1)}" target="_blank" style="color: #1e88e5;">${linkText}</a>`
                      )
                      // Remove tracking pixel images
                      .replace(
                        /<img[^>]+src=["']?https:\/\/vibrant-catbird-399009\.el\.r\.appspot\.com\/images\/\S+\.png["']?[^>]*>/gi,
                        ""
                      )
                  : "<p>No email body available.</p>",
              }}
              
            />

            {email.attachments && email.attachments.length > 0 && (
            <Box mt={2}>
            <Typography
            variant="subtitle2"
            color="textSecondary"
            fontWeight="bold"
            gutterBottom
            >
            Attachments:
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={1}>
            {email.attachments.map((attachment, index) => (
            <Button
            key={index}
            variant="outlined"
            color="primary"
            href="#"
            target="_blank"
            startIcon={<AttachmentIcon />}
            sx={{
                borderRadius: "8px",
                fontSize: "0.8rem",
                textTransform: "none",
            }}
            >
            {attachment.name}
            </Button>
            ))}
            </Box>
            </Box>
            )}

            {email.logs && email.logs.length > 0 && (
            <Box mt={2}>
            <Typography
            variant="subtitle2"
            color="textSecondary"
            fontWeight="bold"
            gutterBottom
            >
            Activity Logs:
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
            {email.logs.map((log, index) => (
            <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                padding: "8px",
                borderRadius: "6px",
            }}
            >
            <Typography
                variant="body2"
                sx={{ fontWeight: "bold", color: log.event === "Opened" ? "green" : "black" }}
            >
                {log.event}
            </Typography>
            <Typography variant="caption" color="textSecondary">
                {new Date(log.timestamp).toLocaleString()}
            </Typography>
            </Box>
            ))}
            </Box>
            </Box>
            )}
            </CardContent>
            </Card>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setEmail({})}>Close</Button>
            </DialogActions>
            </Dialog>

            <Dialog open={openModal} onClose={handleCloseModal}>
                    <DialogTitle>Tell us more</DialogTitle>
                    <DialogContent>
                        <TextField
                            label=""
                            value= {reason}
                            onChange={(e) => {
                                setReason(e.target.value);
                                setNewComment({
                                    comment: ModalStatus + " : " + e.target.value,
                                    user: Project._id,
                                    userName: user.name,
                                    timestamp: new Date()
                                });
                                
                            }}                          
                            fullWidth
                            multiline
                            rows={4}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseModal}>Cancel</Button>
                        <Button onClick={() => handleSubmit(newComment)}  color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>
              
                <EditSidebar
  open={showEditSidebar}
  onClose={() => setShowEditSidebar(false)}
  decisionMaker={selectedDecisionMaker}
  onUpdate={handleUpdate}
  Project={Project}
/>
<Snackbar
  open={snackbarOpen}
  autoHideDuration={3000}
  onClose={() => setSnackbarOpen(false)}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
>
  <Alert severity={snackbarSeverity} variant="filled" onClose={() => setSnackbarOpen(false)}>
    {snackbarMessage}
  </Alert>
</Snackbar>

            <Dialog
              open={showWeekendDialog}
              onClose={() => setShowWeekendDialog(false)}
            >
              <DialogTitle>Weekend Email Warning</DialogTitle>
              <DialogContent>
                <Typography>
                  Sending emails on weekends typically has lower response rates. Consider scheduling for a weekday.
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  setShowWeekendDialog(false);
                  setOpenPreview(false);
                }}>
                  Cancel
                </Button>
                <Button onClick={() => {
                  setShowWeekendDialog(false);
                  setOpenPreview(true);
                }} color="primary">
                  Continue Anyway
                </Button>
              </DialogActions>
            </Dialog>
                
        </Container>
    );
}

export default Reachouts;